// needs to be kept in sync with the api and db values
export enum TransactionStatus {
    New = 0,
    Pending = 1,
    Successful = 2,
    Failed = 3,
    APIError = 4,
    Expired = 5
}